//export const MEAT_API = 'http://localhost:64189'
export const MEAT_API = 'https://elevatoracessoclienteapi.a2rs10.com.br'

